// Test custom component.
import React, { useState } from 'react';
import styled from '@emotion/styled/macro';
import TriggerAtom from '@atoms/trigger-atoms/trigger-atom';
import vars from '@variables';
import {
  AnnotationAtom,
  HighlightAuthorAtom,
} from '@atoms/text-atoms/text-atoms';

type PrototpeOneProps = {
  className?: string;
  anchorId?: string;
};

type QuoteData = {
  en: string;
  author: string;
};

const PrototypeOne: React.FC<PrototpeOneProps> = ({ className, anchorId }) => {
  const [data, setData] = useState<QuoteData | null>(null);
  const [hasError, setHasError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const API_URL = 'https://programming-quotes-api.herokuapp.com/Quotes/random';

  const handleInteraction = async () => {
    setIsLoading(true);
    fetch(API_URL)
      .then(response => response.json())
      .then(data => {
        setData(data);
        setIsLoading(false);
      })
      .catch(error => {
        console.error(`An error has occured: ${error}`);
        setHasError(true);
        setIsLoading(false);
      });
  };

  return (
    <div
      id={anchorId}
      className={className}
      data-testid="prototype-custom-block"
    >
      <TriggerAtom
        action={handleInteraction}
        buttonText="Generate Quote"
        highlightColour={vars.foodOrange}
      />
      {hasError && (
        <AnnotationAtom>
          Sorry, this isn't quite working as expected{' '}
          <span role="img" aria-label="catterpillar emoji">
            🐛
          </span>
        </AnnotationAtom>
      )}
      {isLoading && !hasError && (
        <AnnotationAtom>
          {' '}
          Loading...
          <span role="img" aria-label="egg timer emoji">
            ⏳
          </span>
        </AnnotationAtom>
      )}
      {data && !isLoading && !hasError && (
        <div>
          <AnnotationAtom>{data.en}</AnnotationAtom>
          <HighlightAuthorAtom>{data.author}</HighlightAuthorAtom>
        </div>
      )}
    </div>
  );
};

const StyledPrototypeOne = styled(PrototypeOne)`
  margin: ${({ anchorId }) => (anchorId ? vars.spacingL : 'auto')};
  min-height: 20rem;
  ${TriggerAtom} {
    margin: ${vars.spacingM} 0;
  }
  ${HighlightAuthorAtom} {
    margin-top: ${vars.spacingS};
  }
`;

export default StyledPrototypeOne;
